module.exports = __webpack_public_path__ + "img/footerbook.8b556144.png";